module.exports = __webpack_public_path__ + "img/4.7eef6399.jpg";